import React from 'react';
import {connect} from 'react-redux';
import Education from './Education';
import {requestEducation, setCurrentPage} from "../../redux/educational-reducer";
import {Container, Row} from "react-bootstrap";
import {NavLink, withRouter} from "react-router-dom";
import {compose} from "redux";
import style from "./Education.module.css";
import {getPageFromLocation, pushPage} from "../../shared/pagination";

class EducationContainer extends React.Component {

    componentDidMount() {
        this.load();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.location.search !== this.props.location.search) {
            this.load();
        }
    }

    load() {
        this.props.requestEducation(getPageFromLocation(this.props.location), this.props.pageSize);
    }

    onPageChanged = (pageNumber) => {
        pushPage(this.props.history, this.props.location, pageNumber);
    }

    render() {

        return <>
            <div className={'breadcrumdBottom'}>
                <Container className=''>
                    <Row>
                        <div className={'breadcrumdCont'}>
                            <NavLink to={'/'}>
                                <div className={'breadcrumbTitle'}>eLibrary</div>
                            </NavLink>


                            <div className={'breadcrumbItem'}>Учебно-методические пособия</div>


                        </div>
                    </Row>
                </Container>
            </div>


            <div className='container mt-4'>

                <div className='row'>
                    <div className="col-12 col-md-4">
                        <div className={style.educont}>
                            <div className={style.edutitle}>
                                <h1>Учебно-методические пособия</h1>
                            </div>
                            <div className={style.edunav}>
                                <ul>
                                    <li className={style.current}><NavLink to={'/учебныеиздания'}><p>По дате
                                        публикации</p></NavLink></li>
                                    <li><NavLink to={"/учебныеиздания/авторы"}><p>По авторам</p></NavLink></li>
                                    <li><NavLink to={"/учебныеиздания/институты"}><p>По институтам</p></NavLink></li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-8">
                        <Education
                            totalCount={this.props.totalCount}
                            pageSize={this.props.pageSize}
                            currentPage={this.props.currentPage}
                            onPageChanged={this.onPageChanged}
                            articles={this.props.articles}
                            loading={this.props.isFetching}
                        />
                    </div>
                </div>

            </div>

        </>
    }
}

let mapStateToProps = (state) => {
    return {
        totalCount: state.educationalDatePage.totalCount,
        pageSize: state.educationalDatePage.pageSize,
        currentPage: state.educationalDatePage.currentPage,
        articles: state.educationalDatePage.articles,
        isFetching: state.educationalDatePage.isFetching
    }
}


export default compose(
    connect(mapStateToProps, {setCurrentPage, requestEducation}),
    withRouter
)(EducationContainer);